import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { CartProvider } from './context/CartContext'
import App from './App.jsx'
// Primero importamos globals.css para que las variables estén disponibles
import './styles/globals.css'
// Luego importamos el resto de estilos
import './index.css'
import './styles/typography.css'
import './styles/fonts.css'
// Import styles for Ant Design
// import 'antd/dist/antd.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        <App />
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
